import { createRouter, createWebHistory } from "vue-router";
import type { RouteRecordRaw } from "vue-router";
import phoneRoutes from "./phone";
// import Home from "../views/Home.vue";
import Login from "../views/Login/index.vue";
import Profile from "../views/Profile/Profile.vue";
import Balances from "@/views/Balances/Balances.vue";
import CertificateView from "@/views/Certificate/CertificateView.vue";
import CertificateView2 from "@/views/Certificate/CertificateView2.vue";
import CertificateFixed from "@/views/Certificate/CertificateFixed.vue";
import TestLayout from "@/views/TestLayout.vue";
import { storageService } from "@/services/storageService";

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    // name: "Home",
    // component: Home,
    redirect: "/phone/qa",
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/balances",
    name: "Balances",
    component: Balances,
  },
  {
    path: "/certificate/view",
    name: "CertificateView",
    component: CertificateView,
  },
  {
    path: "/certificate/test",
    name: "CertificateFixed",
    component: CertificateFixed,
  },
  {
    path: "/certificate/view2",
    name: "CertificateView2",
    component: CertificateView2,
  },
  {
    path: "/test-layout",
    name: "TestLayout",
    component: TestLayout,
  },
  ...phoneRoutes,
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Public routes that don't require authentication
const whiteList = ["/login"];

// Router guard - check authentication
router.beforeEach((to, _from, next) => {
  // Use storage service to check access token
  const accessToken = storageService.getAccessToken();

  if (accessToken) {
    // User is authenticated
    if (to.path === "/login") {
      // Already logged in, redirect to home
      next({ path: "/" });
    } else {
      // Allow access to protected routes
      next();
    }
  } else {
    // User is not authenticated
    if (whiteList.indexOf(to.path) !== -1) {
      // Allow access to public routes (like /login)
      next();
    } else {
      // Redirect to login for protected routes
      next({ path: "/login" });
    }
  }
});

export default router;
